var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBl = function SvgBl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ACABB1",
    d: "M21.427 9.652h-3.948c0-.72-.584-1.304-1.305-1.304l-1.043 2.087s1.113 3.13 1.078 3.13h1.305c.72 0 1.304-.583 1.304-1.304.72 0 1.304-.584 1.304-1.304h-.043c.72 0 1.348-.584 1.348-1.305ZM2.574 9.652h3.948c0-.72.584-1.304 1.304-1.304l1.044 2.087s-1.113 3.13-1.078 3.13H6.487c-.72 0-1.304-.584-1.304-1.304-.72 0-1.304-.584-1.304-1.304h.043c-.72 0-1.348-.584-1.348-1.305Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M16.174 16.696v.521H7.826v-.521H5.74v2.087h2.087v.521h8.348v-.521h2.087v-2.087h-2.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M7.826 8.349v5.217C7.826 16.76 12 17.74 12 17.74s4.174-.98 4.174-4.174V8.349L12 7.827l-4.174.522Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M16.174 10.434H7.826v3.13h8.348v-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M14.087 5.739v.782l-.522.261-.521-.521V4.695h-2.087v1.566l-.522.521-.522-.26v-.783H7.826v2.608h8.348V5.74h-2.087Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgBl;